export const MOBILE_WIDTH = 847;

export function isMobile() {
    return window != null && window.innerWidth < MOBILE_WIDTH;
}
